import { useAppDispatch, useAppSelector } from '@app/model/store'
import React, { FC } from 'react'
import { TypeFiltersByKeyListButtons } from '@features/Restaurant/RestaurantFilters/model/types'
import s from './FilterIntegratedButtonsTemplate.module.sass'
import { Checkbox } from '@shared/ui/Form/Single/Checkbox'
import { Text } from '@shared/ui/Typography/Text'
import { CheckboxOption } from '@shared/types/fields/fields'
import { setCheckedFilterItemAsync } from '@features/Restaurant/RestaurantFilters/model/thunks'

interface Props {
  typeFilter: TypeFiltersByKeyListButtons
}

const title = {
  rating: ['Рейтинг', 'Рейтинг'],
  price: ['Цена', 'Средний счет'],
}

export const FilterIntegratedButtonsTemplate: FC<Props> = ({ typeFilter }) => {
  const dispatch = useAppDispatch()
  const stateFilters = useAppSelector((store) => store.features.restaurant_filters)
  const { list } = stateFilters.filters[typeFilter]

  const changeChecked = (option: CheckboxOption, checked) => {
    dispatch(
      setCheckedFilterItemAsync({
        filterType: typeFilter,
        itemId: Number(option.id),
        checked: checked,
      }),
    )
  }
  return (
    <div className={s.block}>
      <Text sizes='ML'>{title[typeFilter][1]}</Text>

      <div className={s.list}>
        {list.length ? (
          list.map((tag) => (
            <Checkbox
              key={`checkbox-${tag.id}`}
              option={{
                id: tag.id,
                name: tag.slug,
                label: tag.name,
                disabled: tag.disabled,
              }}
              checked={tag.checked}
              onChange={changeChecked}
              mode={'button'}
              className={s.button}
            />
          ))
        ) : (
          <Text sizes={'M'}>Ничего не найдено</Text>
        )}
      </div>
    </div>
  )
}
